<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true" :text="uploadMsg">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Add New Investigaor / Partner</template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="8">
              <b-row>
                <b-col cols="12" md="12" class="text-center">
                  <span style="color:blue">
                    <b>On submission login credentials will be mailed to the Investigaor or Partner added.</b>
                  </span>
                </b-col>
              </b-row>
              <b-row class="py-4">
                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('fullname')}">
                    <b-form-group label="Full Name *">
                      <b-form-input
                        v-model="fullname"
                        type="text"
                        id="fullname"
                        placeholder="Full Name"
                        required
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('fullname')">
                        <span style="color:red;">{{validation.firstError('fullname')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('email')}">
                    <b-form-group label="Email ">
                      <b-form-input v-model="email" type="email" id="email" placeholder="Email"></b-form-input>
                      <template slot="description" v-if="validation.firstError('email')">
                        <span style="color:red;">{{validation.firstError('email')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('phone')}">
                    <b-form-group label="Phone No *">
                      <b-form-input
                        v-model="phone"
                        type="text"
                        id="phone"
                        placeholder="Phone Number"
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('phone')">
                        <span style="color:red;">{{validation.firstError('phone')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('role')}">
                    <b-form-group label="Role *">
                      <b-form-select  v-model="role" :options="userTypes"></b-form-select>
                      <template slot="description" v-if="validation.firstError('role')">
                        <span style="color:red;">{{validation.firstError('role')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- <b-row class="py-2 justify-content-md-center text-center">
            <b-col cols="12">
              <img v-if="newImage" :src="newImage" width="auto" height="150px" />
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <b-col cols="12" md="6">
              <b-form-group label="Add User Image">
                <b-form-file id="fileInput" :plain="false" v-model="image" @change="showImage"></b-form-file>
              </b-form-group>
            </b-col>
          </b-row>-->
          <b-row class="py-2 justify-content-md-center">
            <span style="color:red">{{msg}}</span>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button variant="outline-primary" size="sm" @click.prevent="inputCheck">Submit</b-button>
            </div>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      msg: null,

      userTypes: [
        { text: "Investigator", value: 0 },
        { text: "Partner", value: 1 },
      ],
      fullname: null,

      
      phone: null,
      email: null,
      password: null,
      
      role: null,

      image: null,
      uploadMsg: "",
      userId: null,
      newImage: null,
      // userRole: localStorage.getItem("role"),
    };
  },
  beforeMount() {
    // if (this.userRole == "Manager") {
    //   this.userTypes = ["Researcher", "Informant", "Subscriber"];
    //   this.getProfile();
    // }
  },

  validators: {
    fullname(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[a-zA-Z ]+$", "Name can only use Letters")
        .minLength(3, "Minimum 3 Characters Needed");
    },

    phone(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^(?=.*[0-9])", "Please Input Valid Number.");
    },
    email(value) {
      return this.Validator.value(value).required("Required Field").email();
    },

    role(value) {
      return this.Validator.value(value).required("Required Field");
    },
  },
  methods: {
    getProfile() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          var user = response.data.data;
          this.division = user.division._id;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    inputCheck() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.addUser();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },
    addUser() {
      this.appLoading = true;
      var user = {};
      user["name"] = this.fullname;

      user["phone"] = this.phone;

      user["email"] = this.email;

      user["usertype"] = this.role;

      var newURL = "/user/add";

      axios({
        method: "POST",
        url: newURL,
        headers: {
          token: localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
  },
};
</script>
